import './WorkLogModal.css';
import closeFormIcon from '../images/close-message.svg';

export default function WorkLogModal({
  bodyComponent,
  title,
  closeShowWorkLogModal,
}) {
  return (
    <div className="worklog-main-modal">
      <div
        className="worklog-main-modal-shadow"
        onClick={closeShowWorkLogModal}
      >
        <div
          className="worklog-main-modal-container"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="worklog-main-modal-header">
            <div className="worklog-header-title">{title}</div>
            <button
              style={{ fontWeight: 'bolder' }}
              className="worklog-header-close-button"
              onClick={closeShowWorkLogModal}
            >
              <img src={closeFormIcon} style={{ height: '10px' }} alt="Icon" />
            </button>
          </div>

          <div className="worklog-main-modal-body">{bodyComponent}</div>
        </div>
      </div>
    </div>
  );
}
